import Link from "../../utils/Link";
import * as React from "react";
import useTranslations from "../../../hooks/useTranslations";
import { BuildingIcon } from "../../icons";
import Activity from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import { ActivityFragment, CampaignSummaryFragment, CompanyMinimalFragment } from '../../../graphql/generated/definitions';

interface CampaignUpdatedActivityProps {
  activity: CampaignUpdatedActivity;
}

type CampaignUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: CampaignSummaryFragment;
};

export function isCampaignUpdatedActivity(
  q: ActivityFragment
): q is CampaignUpdatedActivity {
  return q.key === "campaign.updated";
}

interface CampaignUpdatedActivityProps {
  activity: CampaignUpdatedActivity;
}

export const CampaignUpdatedActivity: React.FC<CampaignUpdatedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="campaignUpdatedActivity"
        visual={<BuildingIcon className="w-10 h-10 text-accent-500" />}
      >
        <Text fontSize="sm">
          {t("activity.labels.campaignUpdated", {
            campaign: (
              <Link to={`/campaigns/${activity.trackable.slug}`}>
                {activity.trackable.name}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
